import { Component } from '@angular/core';
import { ProjectDeliverableTitleGridCell } from '../../models/project-deliverable-title-grid-cell.model';
import { WorkplanRoutes } from 'src/app/roles/da-engineer/workplan/workplan.constants';

@Component({
  standalone: false,
  selector: 'app-project-deliverable-table-renderer',
  templateUrl: './project-deliverable-table-renderer.component.html',
  styleUrls: ['./project-deliverable-table-renderer.component.scss'],
})
export class ProjectDeliverableTableRendererComponent {
  readonly WorkplanRoutes = WorkplanRoutes;
  projectDeliverable?: ProjectDeliverableTitleGridCell<any>;

  agInit(params: { value: ProjectDeliverableTitleGridCell<any> }) {
    this.projectDeliverable = params.value;
  }
}
